// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zjubnjpiajoscjmogyqb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpqdWJuanBpYWpvc2NqbW9neXFiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgxMTMxMzEsImV4cCI6MjA3MzY4OTEzMX0.YtgkebLQM93IG6LTvjhFFeHMh0m5N4XCj9-lRrKVipE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});